<template>
  <div class="content">
    <el-button type="primary" icon="el-icon-refresh" class="commonBtn circulateMode" :plain='circulateMode' @click="evt=>{setMode(1,evt)}">内循环均温</el-button>
    <el-button type="primary" icon="el-icon-smoking" class="commonBtn stiflingMode" :plain='stiflingMode' @click="evt=>{setMode(2,evt)}">环流熏蒸</el-button>
    <el-button type="primary" icon="el-icon-stopwatch" class="commonBtn compensateMode" :plain='compensateMode' @click="evt=>{setMode(3,evt)}">秋冬补冷</el-button>
    <el-button type="primary" icon="el-icon-reading" class="commonBtn ventilateMode" :plain='ventilateMode' @click="evt=>{setMode(4,evt)}">夏季通风</el-button>
    <el-button type="primary" icon="el-icon-brush" class="commonBtn clearErrorMode" plain @click="clearErrorMode">清除故障</el-button>
    <div class="setMacView" :style="`height:${height-100}px;width:${width-270}px`">
      <div class='muitifunctional'>
        <div class='wareMode'>
          <div class='lampWrap'>
            <div>指示灯信号</div>
            <div>开启：<span class="lamp lamp1"></span></div>
            <div>关闭：<span class="lamp lamp2"></span></div>
            <div>故障：<span class="lamp lamp3"></span></div>
            <div>离线：<span class="lamp lamp4"></span></div>
          </div>
          <div class='fanList'>
            <div class='fan fan1' v-if='serStatus.doubleSpeed==1||serStatus.doubleSpeed==2'></div>
            <div class='fan fan2' v-if='serStatus.centrifugal==1'></div>
          </div>
          <div class='tipList'>
            <div :class="['tip tip1',tipStatus1]"></div>
            <div :class="['tip tip2',tipStatus2]"></div>
            <div :class="['tip tip3',tipStatus3]"></div>
            <div :class="['tip tip4',tipStatus4]"></div>
            <div :class="['tip tip5',tipStatus5]"></div>
          </div>
          <div class='tapList'>
            <div class='tap tap1'>双速风机</div>
            <div class='tap tap2'>离心风机</div>
            <div class='tap tap3'>K1</div>
            <div class='tap tap4'>K2</div>
            <div class='tap tap5'>K3</div>
            <div class='tap tap6'>K4</div>
            <div class='tap tap7'>K5</div>
          </div>
        </div>
        <div class='infoWrap'>
          <div>
            <div class='controlMode'>控制模式：{{whzskInfo.remoteStatus==1?'远程':'本地'}}</div>
            <!-- <el-button type="primary" icon="el-icon-video-pause" class="stopAll" plain @click="stopAll">一键停止</el-button> -->
          </div>
          <div class='baseInfoTitle' style="padding-top:10px"><span></span>设备控制面板</div>
          <el-form :model="whzskInfo" label-width="140px">
            <div class='controlPannel'>
              <el-form-item label="电磁阀K1">
                <el-switch 
                  v-model="whzskInfo.k1" 
                  @change='status=>{controlVal(1,status)}'
                  active-text="打开"
                  inactive-text="关闭">
                </el-switch>
              </el-form-item>
              <el-form-item label="电磁阀K2">
                <el-switch 
                  v-model="whzskInfo.k2" 
                  @change='status=>{controlVal(2,status)}'
                  active-text="打开"
                  inactive-text="关闭">
                </el-switch>
              </el-form-item>
              <el-form-item label="电磁阀K3">
                <el-switch 
                  v-model="whzskInfo.k3" 
                  @change='status=>{controlVal(3,status)}'
                  active-text="打开"
                  inactive-text="关闭">
                </el-switch>
              </el-form-item>
              <el-form-item label="电磁阀K4">
                <el-switch 
                  v-model="whzskInfo.k4" 
                  @change='status=>{controlVal(4,status)}'
                  active-text="打开"
                  inactive-text="关闭">
                </el-switch>
              </el-form-item>
              <el-form-item label="电磁阀K5">
                <el-switch 
                  v-model="whzskInfo.k5" 
                  @change='status=>{controlVal(5,status)}'
                  active-text="打开"
                  inactive-text="关闭">
                </el-switch>
              </el-form-item>
              <el-form-item label="离心风机">
                <el-switch 
                  v-model="whzskInfo.centrifugal" 
                  @change='status=>{controlFan(1,status)}'
                  active-text="启动"
                  inactive-text="停止">
                </el-switch>
              </el-form-item>
              <el-form-item label="双速风机">
                <el-radio-group 
                  @change='status=>{controlFan(2,status)}'
                  v-model="whzskInfo.doubleSpeed">
                  <el-radio label="2">高速模式</el-radio>
                  <el-radio label="1">低速模式</el-radio>
                  <el-radio label="0">停止</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
          </el-form>
          <div class='baseInfoTitle' style="padding-top:10px" v-if='errorInfo.length>0'><span></span>设备故障信息</div>
          <div class='controlPannel' v-if='errorInfo.length>0'>
            <div class='errorInfo'>
              <p v-for='(item,index) in errorInfo' :key='index'>{{item}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '../../axios.js'
import createSocket from '../../webSocket.js'
export default {
  props:{
    width:Number,
    height:Number,
    wareId:Number
  },
  data(){
    return{
      whzskInfo:{},
      loading:true,
      serStatus:{},
      timer1:null,
      timer2:null,
      timer3:null,
      timer4:null,
      timer5:null,
      tipStatus1:'',
      tipStatus2:'',
      tipStatus3:'',
      tipStatus4:'',
      tipStatus5:'',
      errorInfo:[],
      ws:null,
      circulateMode:true,
      stiflingMode:true,
      compensateMode:true,
      ventilateMode:true
    }
  },
  watch:{
    wareId(){
      this.getWhzsk()
    }
  },
  created(){
    if(this.wareId){
      this.getWhzsk()
    }
  },
  destroyed(){
    this.ws.close()
  },
  methods:{
    socket(){
      this.ws=createSocket('/websocket/whzsk')
      this.ws.onmessage=this.wsMessage;
    },
    getWhzsk(){
      if(!this.ws||this.ws.readyState==3){
        this.socket()
        this.sendId()
      }else{
        this.sendId()
      }
      axios.get(`/system/whzsk/getWhzskByWareId/${this.wareId}`).then(res=>{
        if(res){
          this.setWhzskInfo(res.data)
        }
      })
    },
    sendId(){
      if(this.ws.readyState===1){
        this.ws.send(this.wareId);
      }else{
        setTimeout(()=>{
          this.sendId()
        },500)
      }
    },
    wsMessage(res){
      let data=JSON.parse(res.data);
      this.setWhzskInfo(data);
    },
    setWhzskInfo(res){
      if(res){
        let doubleSpeed='0',k1=false,k2=false,k3=false,k4=false,k5=false,errInfo=[];
        clearInterval(this.timer1)
        clearInterval(this.timer2)
        clearInterval(this.timer3)
        clearInterval(this.timer4)
        clearInterval(this.timer5)
        if(res.doubleSpeed||res.doubleSpeed==0){
          doubleSpeed=res.doubleSpeed.toString();
          if(res.doubleSpeed==3){
            errInfo.push('双速风机故障')
          }
        }
        if(res.centrifugal==2){
          errInfo.push('离心风机故障')
        }
        if(res.k1==1||res.k1==5||res.k1==9){
          k1=true;
        }else{
          k1=false
        }
        if(res.k1==9){
          errInfo.push('k1阀打开故障')
        }else if(res.k1==10){
          errInfo.push('k1阀关闭故障')
        }
        if(res.k2==1||res.k2==5||res.k2==9){
          k2=true
        }else{
          k2=false
        }
        if(res.k2==9){
          errInfo.push('k2阀打开故障')
        }else if(res.k2==10){
          errInfo.push('k2阀关闭故障')
        }
        if(res.k3==1||res.k3==5||res.k3==9){
          k3=true
        }else{
          k3=false
        }
        if(res.k3==9){
          errInfo.push('k3阀打开故障')
        }else if(res.k3==10){
          errInfo.push('k3阀关闭故障')
        }
        if(res.k4==1||res.k4==5||res.k4==9){
          k4=true
        }else{
          k4=false
        }
        if(res.k4==9){
          errInfo.push('k4阀打开故障')
        }else if(res.k4==10){
          errInfo.push('k4阀关闭故障')
        }
        if(res.k5==1||res.k5==5||res.k5==9){
          k5=true
        }else{
          k5=false
        }
        if(res.k5==9){
          errInfo.push('k5阀打开故障')
        }else if(res.k5==10){
          errInfo.push('k5阀关闭故障')
        }
        this.errInfo=errInfo
        let info={
          remoteStatus:res.remoteStatus,
          centrifugal:res.centrifugal==1?true:false,
          doubleSpeed:doubleSpeed,
          k1:k1,
          k2:k2,
          k3:k3,
          k4:k4,
          k5:k5
        };
        this.whzskInfo=info;
        this.serStatus=res;
        if(res.internalAve==1){
          this.circulateMode=false
        }else{
          this.circulateMode=true
        }
        if(res.recirculation==1){
          this.stiflingMode=false
        }else{
          this.stiflingMode=true
        }
        if(res.coldinAutumn==1){
          this.compensateMode=false
        }else{
          this.compensateMode=true
        }
        if(res.summerVent==1){
          this.ventilateMode=false;
        }else{
          this.ventilateMode=true
        }
        if(res.k1==0){
          this.tipStatus1=''
        }else if(res.k1==1){
          this.tipStatus1='tipOn'
        }else if(res.k1==2){
          this.tipStatus1='tipOff'
        }else{
          this.setTimer1(res.k1)
        }
        if(res.k2==0){
          this.tipStatus2=''
        }else if(res.k2==1){
          this.tipStatus2='tipOn'
        }else if(res.k2==2){
          this.tipStatus2='tipOff'
        }else{
          this.setTimer2(res.k2)
        }
        if(res.k3==0){
          this.tipStatus3=''
        }else if(res.k3==1){
          this.tipStatus3='tipOn'
        }else if(res.k3==2){
          this.tipStatus3='tipOff'
        }else{
          this.setTimer3(res.k3)
        }
        if(res.k4==0){
          this.tipStatus4=''
        }else if(res.k4==1){
          this.tipStatus4='tipOn'
        }else if(res.k4==2){
          this.tipStatus4='tipOff'
        }else{
          this.setTimer4(res.k4)
        }
        if(res.k5==0){
          this.tipStatus5=''
        }else if(res.k5==1){
          this.tipStatus5='tipOn'
        }else if(res.k5==2){
          this.tipStatus5='tipOff'
        }else{
          this.setTimer5(res.k5)
        }
      }
    },
    setTimer1(num){
      let a=0;
      this.timer1=setInterval(()=>{
        if(num==5){
          if(a==0){
            this.tipStatus1='tipOn'
            a++
          }else{
            this.tipStatus1=''
            a--
          }
        }else if(num==6){
          if(a==0){
            this.tipStatus1='tipOff'
            a++
          }else{
            this.tipStatus1=''
            a--
          }
        }else if(num==9){
          if(a==0){
            this.tipStatus1='tipOn'
            a++
          }else{
            this.tipStatus1='tipError'
            a--
          }
        }else if(num==10){
          if(a==0){
            this.tipStatus1='tipOff'
            a++
          }else{
            this.tipStatus1='tipError'
            a--
          }
        }
      },300)
    },
    setTimer2(num){
      let a=0;
      this.timer2=setInterval(()=>{
        if(num==5){
          if(a==0){
            this.tipStatus2='tipOn'
            a++
          }else{
            this.tipStatus2=''
            a--
          }
        }else if(num==6){
          if(a==0){
            this.tipStatus2='tipOff'
            a++
          }else{
            this.tipStatus2=''
            a--
          }
        }else if(num==9){
          if(a==0){
            this.tipStatus2='tipOn'
            a++
          }else{
            this.tipStatus2='tipError'
            a--
          }
        }else if(num==10){
          if(a==0){
            this.tipStatus2='tipOff'
            a++
          }else{
            this.tipStatus2='tipError'
            a--
          }
        }
      },300)
    },
    setTimer3(num){
      let a=0;
      this.timer3=setInterval(()=>{
        if(num==5){
          if(a==0){
            this.tipStatus3='tipOn'
            a++
          }else{
            this.tipStatus3=''
            a--
          }
        }else if(num==6){
          if(a==0){
            this.tipStatus3='tipOff'
            a++
          }else{
            this.tipStatus3=''
            a--
          }
        }else if(num==9){
          if(a==0){
            this.tipStatus3='tipOn'
            a++
          }else{
            this.tipStatus3='tipError'
            a--
          }
        }else if(num==10){
          if(a==0){
            this.tipStatus3='tipOff'
            a++
          }else{
            this.tipStatus3='tipError'
            a--
          }
        }
      },300)
    },
    setTimer4(num){
      let a=0;
      this.timer4=setInterval(()=>{
        if(num==5){
          if(a==0){
            this.tipStatus4='tipOn'
            a++
          }else{
            this.tipStatus4=''
            a--
          }
        }else if(num==6){
          if(a==0){
            this.tipStatus4='tipOff'
            a++
          }else{
            this.tipStatus4=''
            a--
          }
        }else if(num==9){
          if(a==0){
            this.tipStatus4='tipOn'
            a++
          }else{
            this.tipStatus4='tipError'
            a--
          }
        }else if(num==10){
          if(a==0){
            this.tipStatus4='tipOff'
            a++
          }else{
            this.tipStatus4='tipError'
            a--
          }
        }
      },300)
    },
    setTimer5(num){
      let a=0;
      this.timer5=setInterval(()=>{
        if(num==5){
          if(a==0){
            this.tipStatus5='tipOn'
            a++
          }else{
            this.tipStatus5=''
            a--
          }
        }else if(num==6){
          if(a==0){
            this.tipStatus5='tipOff'
            a++
          }else{
            this.tipStatus5=''
            a--
          }
        }else if(num==9){
          if(a==0){
            this.tipStatus5='tipOn'
            a++
          }else{
            this.tipStatus5='tipError'
            a--
          }
        }else if(num==10){
          if(a==0){
            this.tipStatus5='tipOff'
            a++
          }else{
            this.tipStatus5='tipError'
            a--
          }
        }
      },300)
    },
    setLoading(){
      this.loading=this.$loading({
        text:'正在发送指令，请稍等',
        target:document.querySelector('.busWrap'),
        background: 'rgba(0, 0, 0, 0.7)'
      })
    },
    setMode(num,evt){
      let target = evt.target;
      if(target.nodeName == "SPAN"){
        target = evt.target.parentNode;
      }
      if(num==1){
        if(this.serStatus.internalAve==1){
          this.changeMode(1,0);
          this.circulateMode=false;
          target.blur();
        }else{
          this.changeMode(1,1);
          this.circulateMode=true
        }
      }else if(num==2){
        if(this.serStatus.recirculation==1){
          this.changeMode(2,0)
          this.stiflingMode=false;
          target.blur();
        }else{
          this.changeMode(2,1)
          this.stiflingMode=true
        }
      }else if(num==3){
        if(this.serStatus.coldinAutumn==1){
          this.changeMode(3,0);
          this.compensateMode=false;
          target.blur();
        }else{
          this.changeMode(3,1)
          this.compensateMode=true
        }
      }else if (num==4){
        if(this.serStatus.summerVent==1){
          this.changeMode(4,0);
          this.ventilateMode=false;
          target.blur();
        }else{
          this.changeMode(4,1)
          this.ventilateMode=true
        }
      }
    },
    changeMode(num,status){
      this.setLoading();
      this.ws.close()
      axios.post("/system/whzsk/ctrlMode",{wareId:this.wareId,num:num,status:status}).then(res=>{
        this.loading.close();
        this.getWhzsk()
        if(res){
          this.$message({
            message:res.msg,
            type:'success',
            duration:1000
          })
        }
      })
    },
    clearErrorMode(evt){
      let target = evt.target;
      if(target.nodeName == "SPAN"){
        target = evt.target.parentNode;
      }
      target.blur();
      this.setLoading();
      this.ws.close()
      axios.post('/system/whzsk/clearError',{wareId:this.wareId}).then(res=>{
        this.loading.close();
        this.getWhzsk()
        if(res){
          this.$message({
            message:res.msg,
            type:'success',
            duration:1000
          })
        }
      })
    },
    controlFan(num,status){
      let FanStatus=0;
      if(num==1){
        FanStatus=status?1:0
      }else{
        FanStatus=status
      }
      this.setLoading()
      this.ws.close()
      axios.post('/system/whzsk/ctrlFan',{wareId:this.wareId,num:num,status:FanStatus}).then(res=>{
        this.loading.close();
        this.getWhzsk()
        if(res){
          this.$message({
            message:res.msg,
            type:'success',
            duration:1000
          })
        }
      })
    },
    controlVal(num,status){
      this.setLoading()
      this.ws.close()
      axios.post('/system/whzsk/ctrlVal',{wareId:this.wareId,num:num,status:status?1:0}).then(res=>{
        this.loading.close();
        this.getWhzsk()
        if(res){
          this.$message({
            message:res.msg,
            type:'success',
            duration:1000
          })
        }
      })
    },
    // stopAll(){
    //   if(this.serStatus.internalAve==1){
    //     this.changeMode(1,0)
    //   }else if(this.serStatus.recirculation==1){
    //     this.changeMode(2,0)
    //   }else if(this.serStatus.coldinAutumn==1){
    //     this.changeMode(3,0)
    //   }else if(this.serStatus.summerVent==1){
    //     this.changeMode(4,0)
    //   }else{
    
    //   }
    // }
  }
}
</script>

<style lang="scss" scoped>
  .circulateMode{
    left: 15px;
  }
  .stiflingMode{
    left: 140px;
  }
  .compensateMode{
    left: 275px;
  }
  .ventilateMode{
    left: 410px;
  }
  .clearErrorMode{
    left: 545px
  }
  .muitifunctional{
    display: flex;
    .wareMode{
      width: 763px;
      height: 763px;
      border: 1px solid rgba(0,0,0,.05);
      background-image: url('../../assets/ware/ware.png');
      background-size: cover;
      position: relative;
      perspective:2000;
      .lampWrap{
        position: absolute;
        top: 20px;
        left: 20px;
        font-size: 14px;
        font-weight: 600;
        color: rgba(0,0,0,.5);
        div{
          display: flex;
          align-items: center;
          line-height: 30px;
          height: 30px;
          .lamp{
            width: 20px;
            height: 20px;
            border-radius: 50%;
            display: inline-block;
          }
          .lamp1{background-color: rgb(0, 255, 0)};
          .lamp2{background-color: rgb(255, 0, 0)}
          .lamp3{background-color: rgb(253, 208, 9)}
          .lamp4{background-color: gray}
        }
      }
      .fanList{
        .fan{
          position: absolute;
          background-size: cover;
        }
        .fan1{
          background-image: url('../../assets/ser/fan1.gif');
          width: 66px;
          height: 32px;
          left: 316px;
          top:52px;
        }
        .fan2{
          background-image: url('../../assets/ser/fan2.gif');
          width: 41px;
          height: 39px;
          top: 216px;
          left: 316px;
        }
      }
      .tipList{
        .tip{
          height: 10px;
          width: 10px;
          border-radius: 50%;
          background-color: gray;
          position: absolute;
        }
        .tip1{
          left: 360px;
          top:92px;
          transform: rotateY(45deg)
        }
        .tip2{
          left: 240px;
          top: 140px;
          transform: rotateY(-45deg)
        }
        .tip3{
          left: 340px;
          top: 263px;
          transform: rotateY(30deg)
        }
        .tip4{
          left: 470px;
          top: 180px;
          transform: rotateY(45px)
        }
        .tip5{
          left: 388px;
          top: 227px;
          transform: rotateY(-45px)
        }
        .tipOn{background-color: rgb(0, 255, 0)}
        .tipOff{background-color: rgb(255, 0, 0)}
        .tipError{background-color: rgb(253, 208, 9)}
      }
      .tapList{
        .tap{
          font-size: 18px;
          font-weight: 600;
          position: absolute;
          color: blue
        }
        .tap1{
          left: 325px;
          top: 35px;
          font-size: 14px
        }
        .tap2{
          left: 300px;
          top: 200px;
          font-size: 14px
        }
        .tap3{
          left: 350px;
          top: 110px;
        }
        .tap4{
          left: 255px;
          top: 135px
        }
        .tap5{
          left:310px;
          top: 260px
        }
        .tap6{
          left: 450px;
          top: 190px
        }
        .tap7{
          left: 400px;
          top: 220px
        }
      }
    }
    .infoWrap{
      border: 1px solid rgba(0,0,0,.05);
      flex: 1;
      margin-left: 10px;
      padding: 0 10px 10px 10px;
      position: relative;
      .controlMode{
        font-size: 12px;
        font-weight: 550;
        padding: 10px 0 0 10px;
      }
      .stopAll{
        position: absolute;
        right: 10px;
        top: 15px
      }
      .controlPannel{
        background: rgba(255,255,255,0.63);
        box-shadow: inset 0 1px 1px 0 #fff,
        0 3px 7px 0 rgba(0,0,0,0.2);
        border-radius: 8px;
        padding: 12px;
        box-sizing: border-box;
        display: flex;
        flex-wrap: wrap;
        .errorInfo{
          font-size: 12px;
          font-weight: 600;
          color: red;
          p{
            height: 20px;
            line-height: 20px
          }
        }
      }
    }
  }
</style>